export const SENDBIRD_TOKEN_ID = 'sendbird_access_token';
